import { supertypeClass, property } from '@haventech/amorphic';
import { CashFlow } from './CashFlow';
import { EarnedIncome } from './EarnedIncome';

@supertypeClass({ toClient: true, toServer: true })
export class Income extends CashFlow {
  @property()
  taxRate: number = 0.33;

  @property({ getType: () => EarnedIncome })
  earnedIncome: EarnedIncome;

  constructor() {
    super();
  }

  static new(customer?, amount?, subtype?, title?) {
    return new Income().init(customer, amount, subtype, title);
  }

  init(customer?, amount?, subtype?, title?) {
    super.init(customer, 'income', subtype || 'general', amount || 0, title || '');
    return this;
  }

  getAmount(flow) {
    return flow.amount - flow.amount * this.taxRate;
  }

  adjustFlow(flow) {
    flow.amount += flow.amount * this.customer.settings.inflation;
  }
}
